import { Typography } from '@/components';
import { OfferDetails } from '../../types';
import { useTranslation } from 'react-i18next';
import { ASSETS_BASE_URL } from '@/config';

export type InterestSectionProps = {
  readonly offer: OfferDetails;
};

export function InterestSection({ offer }: InterestSectionProps) {
  const { t } = useTranslation(['offers']);

  return (
    <section className="mb-6">
      <Typography as="h4" color="primary" size="title" weight="semibold">
        {t('General Details')}
      </Typography>
      <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1 italic">
        {t(
          'This section outlines the main indicative terms of this Expression of Interest. Please note that all information is non-binding and subject to document review and further negotiations.'
        )}
      </Typography>

      <div className="mt-6">
        <Typography as="p" size="body-2" weight="semibold">
          {t('Buyer comments')}
        </Typography>
        <Typography as="span" size="body-2" color="primary" className="whitespace-pre-line">
          {offer.expressInterest ? offer.expressInterest : 'No info provided'}
        </Typography>
      </div>
      <div className="mt-6">
        <Typography as="p" size="body-2" weight="semibold">
          {t('Formal Expression of Interest')}
        </Typography>
        {offer?.eoiFile ? (
          <Typography as="span" size="body-2">
            <a
              href={`${ASSETS_BASE_URL}/${offer.eoiFile}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary-700"
            >
              {t('Press to see the document')}
            </a>
          </Typography>
        ) : (
          <Typography as="span" size="body-2" color="primary">
            {t('No document provided')}
          </Typography>
        )}
      </div>
    </section>
  );
}
